import { Injectable } from '@angular/core';

export const STORAGE_KEYS = {
  ROLE: 'role',
  USER: 'user',
  TOKEN: 'token',
  FCM_TOKEN: 'fcm_token',
  PROFILE: 'profile',
  PROFILE_ID: 'profile_id',
  PERMISSIONS: 'permissions',
  USERTYPE: 'userType',
  PAYFILTERSPREFS: 'payFilterPrefs',
  TASKFILTERPREFS: 'taskFilterPrefs',
  AVATAR: 'avatar',
  TENANT_ID: 'tenant_id',
  SETTLEMENT: 'settlement'
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  saveItem(key: string, data: any): void {
    try {
      if (key && data) {
        const mappedData = (typeof data) === 'string' ? data : JSON.stringify(data);
        sessionStorage.setItem(key, mappedData);
      }
    } catch (error) {
      throw new Error(`Something wrong happened when saving ${key} in session storage`);
    }
  }

  getItem(key: string): any {
    try {
      if (key) {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
      }
    } catch (error) {
      throw new Error(`Something wrong happened when getting ${key} from session storage`);
    }
  }

  removeItem(key: string) {
    try {
      if (key) {
        sessionStorage.removeItem(key);
      }
    } catch (error) {
      throw new Error(`Something wrong happened when deleting ${key} from session storage`);
    }
  }

}
